import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as common from '../common/dialogs'

@ngCore.Component({
  imports: [
    ds.layout.page.Component,
    ds.overlay.confirmation.Component,
    ds.table.Component,
    common.action.Component,
  ],
  selector: 'atn-mosaic-dev-actions-page',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
export class Page {
  /** @see {@link AtnMosaicEcService.actionsCollection} */
  public readonly actionsEc = ngCore.inject(state.mosaic.dev.actions.Collection)

  /** Canonical table input for Mosaic action definitions. */
  public readonly actionsTableConfig = {
    collection: this.actionsEc,
    view: {
      creation: () => this.addClickHandlerCallback(),
      search: true,
      title: 'Actions',
    },
  } satisfies ds.table.ec.Config.Input<state.mosaic.dev.actions.TypeParams>

  public addClickHandlerCallback = () => {
    const source = 'Table.AddButton.Clicked'
    if (
      this.actionsEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal()
    ) {
      this.actionsEc.plugins.editingPlugin.feature.actions.discard
        .from(source)
        .dispatch({
          current: true,
        })
    }

    // add new
    this.actionsEc.plugins.editingPlugin.feature.actions.edit
      .from(source)
      .dispatch()
  }

  public confirmDeletionClickHandler(): void {
    this.actionsEc.plugins.editingPlugin.feature.actions.submit
      .from('Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  public cancelDeletionClickHandler(): void {
    this.actionsEc.plugins.editingPlugin.feature.actions.discard
      .from('Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
